import { useClassName } from '../../../hooks';
export const usePageSplitClasses = (optionalClassName, type) => {
    const mainClassName = 'page-split';
    const pageSplit = useClassName({
        className: mainClassName,
        optionalClassName,
    });
    const pageSplitTyped = useClassName({
        className: mainClassName,
        optionalClassName,
        modifier: type,
    });
    const dividerHitbox = useClassName({
        className: mainClassName,
        append: 'divider-hitbox',
        optionalClassName,
    });
    const dividerHitboxType = useClassName({
        className: mainClassName,
        append: 'divider-hitbox',
        optionalClassName,
        modifier: type,
    });
    const divider = useClassName({
        className: mainClassName,
        append: 'divider',
        optionalClassName,
    });
    const dividerType = useClassName({
        className: mainClassName,
        append: 'divider',
        optionalClassName,
        modifier: type,
    });
    const panelResizable = useClassName({
        className: mainClassName,
        append: 'panel-resizable',
        optionalClassName,
    });
    const panelFlex = useClassName({
        className: mainClassName,
        append: 'panel-flex',
        optionalClassName,
    });
    return {
        pageSplit: `${pageSplit} ${pageSplitTyped}`,
        dividerHitBox: `${dividerHitbox} ${dividerHitboxType}`,
        divider: `${divider} ${dividerType}`,
        panelResizable,
        panelFlex,
    };
};
//# sourceMappingURL=usePageSplitClasses.js.map